import getContentForToast from './get_content_for_toast';

// This wrapper exists primarily so we can set the key from the Toasts component,
// and don't have to worry about setting it in each individual content component.
export default function Toast({ toast }) {
  return getContentForToast(toast);
}
